/**
 * The rendered height of an element, in whole pixels.
 *
 * The border box is what actually occupies space on the page, so it is what both
 * callers want — reporting the frame height to an embedding host, and reserving room
 * for the mobile cart sheet. A `ResizeObserver` entry carries that measurement already,
 * so passing one avoids a second forced layout; without one the element is measured
 * directly.
 *
 * Ceiled, because a fractional height truncated downwards leaves the page a pixel short
 * of the thing it was measuring.
 */
export const measureHeight = (element: HTMLElement, entry?: ResizeObserverEntry): number => {
  const height = entry?.borderBoxSize?.[0]?.blockSize ?? entry?.contentRect.height ?? element.getBoundingClientRect().height;

  return Math.ceil(height);
};
